export const mapServiceDetails = {
  'outlook-calendar': {
    icon: {
      src: 'images/msgraphcalendar-icon.png',
      alt: 'Outlook Calendar Icon',
    },
    displayName: 'Outlook Calendar',
    descriptionList: [
      'Automatically add moderated interviews to your calendar',
    ],
  },
};
